import { TRPCClientError } from "@trpc/client";
import { useModal } from "@v2/store/modalStore";
import { billingUtils } from "@v2/trpc/routes/billing";
import {
  subscriptionRouter,
  subscriptionUtils,
} from "@v2/trpc/routes/subscription";
import { workspaceUtils } from "@v2/trpc/routes/workspace";

const useInitializeSubscriptionUpdateMutation = ({
  onClose,
}: { onClose?: () => void } = {}) => {
  const { openModal } = useModal();

  const {
    mutateAsync: initializeSubscriptionUpdate,
    isPending,
    data,
  } = subscriptionRouter.initializeSubscriptionUpdate.useMutation({
    onSuccess: (data) => {
      void workspaceUtils.getUserWorkspacesList.invalidate();
      void subscriptionUtils.getActiveSubscription.invalidate();
      void workspaceUtils.getPublishedElementsUsage.invalidate();
      void workspaceUtils.getReploSitesUsage.invalidate();
      void workspaceUtils.getShopifyThemeProjectsUsage.invalidate();
      void billingUtils.getNextCorePlanBillingDate.invalidate();

      if (
        window &&
        data.success &&
        data.confirmationRequired &&
        data.confirmationUrl
      ) {
        window.location.href = data.confirmationUrl;
      }
    },
    onError: (error) => {
      if (error instanceof TRPCClientError) {
        const errorData = error.data as any;
        const errorKey = errorData?.userFacingDetails?.key;
        if (
          errorKey === "integrationNotFoundForBilling" ||
          errorKey === "notFound"
        ) {
          onClose?.();
          openModal({
            type: "billingErrorModal",
            props: {},
          });
          return;
        }
      }
    },
  });

  return {
    initializeSubscriptionUpdate,
    isLoading: isPending,
    data,
  };
};

export default useInitializeSubscriptionUpdateMutation;
